<template>
  <div id="uploader">
    <div v-if="isMobile">
      <router-view />
    </div>
    <div v-if="!isMobile">
      <p>请您使用手机访问</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate, formatConversion } from "@/plugins/getdate";
import { myPowers } from "@/api/userCenter";
import { listLib } from '@/api/lib'
export default {
  data () {
    return {
      isMobile: true,
      isTime: true
    };
  },
  methods: {
    ...mapActions(["setIsMobile"]),
    ...mapActions(["setExpirationTime"]),
    ...mapActions(["setToken"]),
    ...mapActions(["setCreateUid"]),
    ...mapActions(["setPowers"]),
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    transTime (time) {
      if (time === "") {
        return "";
      } else {
        var result = "";
        if (time >= 1000) {
          var day = parseInt(time / (24 * 60 * 60 * 1000));
          var hour = parseInt(
            (time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
          );
          var minute = parseInt(
            ((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) / (60 * 1000)
          );
          var second = parseInt(
            (((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) %
              (60 * 1000)) /
            1000
          );
          // if (day != 0) {
          //   result += day + "天";
          // }
          // if (hour != 0) {
          //   result += hour + "时";
          // }
          if (minute != 0) {
            result += minute + ":" + second;
          } else if (minute < 10) {
            result += '0' + minute + ":" + second;
          } else {
            result += '0' + minute + ":" + second;
          }
          // if (second != 0) {
          //   result += second;
          // }
        }
        if (result == "") {
          result = "00:00";
        }
        return result;
      }
    },


    //获取权限
    async myPowersAsync () {
      let { status, data, message } = await myPowers();
      if (status) {
        let libData = await listLib({ pageSize: 100 });
        let libList = [];
        if (libData.status) {
          for (let i = 0; i < libData.data.length; i++) {
            if (libData.data[i].status === 1) {
              libList.push("lib-" + libData.data[i].id);
            }
          }
        } else {
          this.$message.error(libData.message);
        }
        if (data[0] === "admin") {
          this.setPowers(libList)
        } else {
          this.setPowers(data);
        }

      }
    },
  },
  created () {
    console.log(this.$route.query.haveTimeOut);
    console.log(new Date().getTime() + 3600 * 1000);
    if (this.$route.query.haveTimeOut == 'false') {
      localStorage.setItem('isQcode', true)
      this.setExpirationTime(this.$route.query.date)
    } else {
      localStorage.setItem('isQcode', false)
      this.setExpirationTime(new Date().getTime() + 3600 * 1000)
    }
    // console.log(formatConversion('1592903733'))
    // setInterval(() => {

    // let data = new Date("2020-06-23 17:15:33");
    // let now = new Date();
    // let cha = data.getTime(data) - now.getTime(now);
    // console.log(this.transTime(cha));
    // }, 1000);
    this.setToken(this.$route.query.token)
    this.setCreateUid(this.$route.query.createUid)

    this.myPowersAsync()
    // this.setPowers(JSON.parse(this.$route.query.powers))
    // let cUid = window.location.href.split("%")[2]
    // cUid = cUid.substr(0,cUid.length - 1)
    // this.setCreateUid(cUid)
    // this.setToken(window.location.href.split("?")[1].split("%")[0]);
    // this.setExpirationTime(window.location.href.split("%")[1])
  },
  mounted () {
    if (this._isMobile()) {
      // alert("手机端");
      this.isMobile = true;
      this.setIsMobile(true);
    } else {
      // alert("pc端");
      this.isMobile = false;
      this.setIsMobile(false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./mobileUpdate.scss";
</style>